import { render, staticRenderFns } from "./addStorage.vue?vue&type=template&id=c16fa880&scoped=true"
import script from "./addStorage.vue?vue&type=script&lang=js"
export * from "./addStorage.vue?vue&type=script&lang=js"
import style0 from "./addStorage.vue?vue&type=style&index=0&id=c16fa880&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16fa880",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c16fa880')) {
      api.createRecord('c16fa880', component.options)
    } else {
      api.reload('c16fa880', component.options)
    }
    module.hot.accept("./addStorage.vue?vue&type=template&id=c16fa880&scoped=true", function () {
      api.rerender('c16fa880', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/logisticsSystem/stockManagement/toAuditReturn/addStorage.vue"
export default component.exports